<template>

    <!-- Back to Top -->
    <div class="backtotop">
        <a :href="`#${idhref}`" role="link" aria-describedby="Back To the Top">

            <svg enable-background="new 0 0 32 32" height="32px" id="backtotopsvg" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Arrow_Up_Circle"><path d="M16,0C7.163,0,0,7.164,0,16c0,8.837,7.163,16,16,16c8.836,0,16-7.163,16-16C32,7.164,24.836,0,16,0z M16,30   C8.268,30,2,23.732,2,16S8.268,2,16,2c7.732,0,14,6.268,14,14S23.732,30,16,30z" fill="#121313"/>
                <path d="M16.715,6.293C16.527,6.107,16.264,6,16,6c-0.263,0-0.526,0.108-0.714,0.293l-6.999,6.899   c-0.395,0.391-0.394,1.024,0,1.414c0.395,0.391,1.034,0.391,1.429,0l5.275-5.2V25c0,0.552,0.452,1,1.01,1   c0.558,0,1.01-0.448,1.01-1V9.407l5.275,5.2c0.394,0.39,1.034,0.39,1.428,0c0.394-0.391,0.394-1.024,0-1.414L16.715,6.293z" fill="#121313"/>
                </g><g/><g/><g/><g/><g/><g/>
            </svg>

        </a>
    </div>

</template>

<script>

    export default{
        name: 'BackToTopElement',
        props:{

            idhref:{
                type: String,
                required: true
            }

        }

    }

</script>